@if (!isLoading && orderConfirmationData) {
<div class="page-wrap">
	<div class="order-card-panel">
		<div class="row row-cols-1 row-cols-md-2 row-cols-lg-5 g-3 mb-3">
			<div class="col info-box-spacing">
				<div class="info-box">
					<div class="info-label">Quote Request #</div>
					<div class="info-value">{{ orderConfirmationData?.quoteNo }}</div>
				</div>
			</div>
			<div class="col">
				<div class="info-box">
					<div class="info-label">Quote #</div>
					<div class="info-value">{{ orderConfirmationData?.quoteNo }}</div>
				</div>
			</div>
			<div class="col">
				<div class="info-box">
					<div class="info-label">Job/Po Number</div>
					<div class="info-value">{{ orderConfirmationData?.purchaseOrderNumber || 'NA' }}</div>
				</div>
			</div>
			<div class="col">
				<div class="info-box">
					<div class="info-label">Brand</div>
					<div class="info-value">{{ orderConfirmationData?.brandName || 'NA' }}</div>
				</div>
			</div>
			<div class="col">
				<div class="info-box">
					<div class="info-label">Created On</div>
					<div class="info-value">{{ formatDisplayDate(orderConfirmationData?.quoteValidFrom) }}</div>
				</div>
			</div>
		</div>
	</div>

	<div class="order-card-panel">
		<div class="section-title">Shipping Address</div>
		<div class="row mb-2">
			<div class="col-md-4">
				<div class="field-label">Job Site Name</div>
<div class="field-value">{{ orderConfirmationData?.companyName !== "" ? orderConfirmationData?.companyName : '-' }}</div>			</div>
			<div class="col-md-4">
				<div class="field-label">Job Address</div>
				<div class="field-value">{{ orderConfirmationData?.deliveryAddress?.line1 }}{{ orderConfirmationData?.deliveryAddress?.line1 && (orderConfirmationData?.deliveryAddress?.line2 || orderConfirmationData?.deliveryAddress?.town || orderConfirmationData?.deliveryAddress?.region?.name || orderConfirmationData?.deliveryAddress?.postalCode || orderConfirmationData?.deliveryAddress?.country?.name) ? ', ' : '' }}{{ orderConfirmationData?.deliveryAddress?.line2 }}{{ orderConfirmationData?.deliveryAddress?.line2 && (orderConfirmationData?.deliveryAddress?.town || orderConfirmationData?.deliveryAddress?.region?.name || orderConfirmationData?.deliveryAddress?.postalCode || orderConfirmationData?.deliveryAddress?.country?.name) ? ', ' : '' }}{{ orderConfirmationData?.deliveryAddress?.town }}{{ orderConfirmationData?.deliveryAddress?.town && (orderConfirmationData?.deliveryAddress?.region?.name || orderConfirmationData?.deliveryAddress?.postalCode || orderConfirmationData?.deliveryAddress?.country?.name) ? ', ' : '' }}{{ orderConfirmationData?.deliveryAddress?.region?.name }}{{ orderConfirmationData?.deliveryAddress?.region?.name && (orderConfirmationData?.deliveryAddress?.postalCode || orderConfirmationData?.deliveryAddress?.country?.name) ? ', ' : '' }}{{ orderConfirmationData?.deliveryAddress?.postalCode }}{{ orderConfirmationData?.deliveryAddress?.postalCode && orderConfirmationData?.deliveryAddress?.country?.name ? ', ' : '' }}{{ orderConfirmationData?.deliveryAddress?.country?.name }}</div>
        <div class="field-label">Phone</div>
        <div class="field-value">{{ getFormattedPhone() }}</div>			
			</div>
			<div class="col-md-4">
				<div class="field-label">Multiple Shipment</div>
				<div class="field-value">{{ orderConfirmationData?.multiShipment ? 'Yes' : 'No' }}</div>
			</div>
		</div>
	</div>

	<div class="order-card-panel">
		<div class="section-title">Additional Information</div>
		<div class="row mb-2 additional-info-grid">
			<div class="col-md-6 additional-info-col">
				<div class="field-label">Shipment Notes / Comments</div>
				<div class="field-value mb-0">{{ getShipmentNotes() }}</div>
			</div>
			<div class="col-md-6 additional-info-col">
				<div class="field-label">Uploaded Files</div>
				@if (getUploadedFiles().length > 0) {
					<div class="uploaded-files-list">
						@for (file of getUploadedFiles(); track $index) {
							<div class="uploaded-file-item" [title]="file?.name || file?.fileName || file?.documentName || file">
								{{ file?.name || file?.fileName || file?.documentName || file }}
								@if (file?.sizeLabel || file?.formattedSize || file?.fileSize) {
									<span class="file-size">({{ file?.sizeLabel || file?.formattedSize || file?.fileSize }})</span>
								}
							</div>
						}
					</div>
				} @else {
					<div class="field-value mb-0">No</div>
				}
			</div>
		</div>
	</div>

	<div class="order-card-panel">
		<div class="section-title">Products Ordered</div>
		<div class="table-responsive">
			<table class="products-table">
				<thead>
					<tr>
						<th>Product</th>
						<th class="text-center">Material#</th>
						<th class="text-center">Qty</th>
						<th class="text-center">Sales Unit</th>
						<th class="text-center">Unit Price</th>
						<th class="text-center">Total Price</th>
						<th>Item Comments</th>
					</tr>
				</thead>
				<tbody>
					@for (item of orderConfirmationData?.entries; track item.entryNumber) {
					<tr>
						<td data-label="Product">
							<div class="product-cell">
								<div class="product-thumb" aria-hidden="true">
									@if (resolveImageUrl(item)) {
										<img [src]="resolveImageUrl(item)" [alt]="item.product?.name || item.product?.code" loading="lazy" />
									} @else {
										<cx-media [container]="item.product?.images?.PRIMARY" [alt]="item.product?.name || item.product?.code">
										</cx-media>
									}
								</div>
								<div class="product-name">
									{{ item.product?.name }}
								</div>
							</div>
						</td>
						<td data-label="P/N" class="text-center">{{ item.product?.code }}</td>
						<td data-label="Qty" class="text-center">
							{{ item.quantity }}
						</td>
						<td data-label="Sales Unit" class="text-center">{{ item.uom }}</td>
						<td data-label="Unit Price" class="text-center">{{ item?.knbrTotalPrice?.listPrice === 0 ? 'Quoted' : item?.knbrTotalPrice?.formatedListPrice }}</td>
						<td data-label="Total Price" class="text-center">{{ item?.totalPrice?.value === 0 ? 'Quoted' : item?.totalPrice?.formattedValue }}</td>
						<td data-label="Item Comments">
							{{ item.entryNote }}
						</td>
					</tr>
					}
				</tbody>
			</table>
		</div>
		<div class="table-totals-row">
			<div class="table-total-item">Total Items: <span>{{ orderConfirmationData?.totalItems || 0 }}</span></div>
			<div class="table-total-item">Total Quantity: <span>{{ orderConfirmationData?.totalUnitCount || 0 }}</span></div>
			<div class="table-total-item">Total Price (Est.): <span>{{ orderConfirmationData?.totalPrice?.value === 0 ? 'Quoted' : orderConfirmationData?.totalPrice?.formattedValue}}</span></div>
		</div>
	</div>

    <div class="text-center mt-3">
		<button type="button" class="btn btn-primary" (click)="backToQuoteHistory()">Back to Quote Request History</button>
	</div>
</div>
}
